import React from 'react';

const JobContext = React.createContext(true);

export const JobProvider = JobContext.Provider;
export const JobConsumer = JobContext.Consumer;
export default JobContext;

export const withJobContext = Component => {
  // eslint-disable-next-line react/display-name
  return props => {
    return (
      <JobConsumer>
        {jobContext => {
          return <Component {...props} jobContext={jobContext} />;
        }}
      </JobConsumer>
    );
  };
};